import { render } from "./app.vue?vue&type=template&id=6ea22944"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
script.render = render

export default script